import { useState } from 'react';
import Header from '../../components/feature/Header';
import Card from '../../components/base/Card';
import Button from '../../components/base/Button';
import Input from '../../components/base/Input';
import { talents } from '../../mocks/talents';
import { clients } from '../../mocks/clients';
import { projects } from '../../mocks/projects';
import ResumeParseConfig from './components/ResumeParseConfig';

export default function ManagementPage() {
  const [activeTab, setActiveTab] = useState('overview');
  const [showConfigModal, setShowConfigModal] = useState(false);
  const [configType, setConfigType] = useState('');

  const totalTalents = talents.length;
  const totalClients = clients.length;
  const totalProjects = projects.length;
  const activeProjects = projects.filter(p => p.status === '招聘中').length;

  const renderOverview = () => (
    <div className="space-y-8">
      {/* 核心指标 */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <Card>
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
              <i className="ri-user-line text-blue-600 text-xl"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">{totalTalents}</div>
              <div className="text-sm text-gray-600">人才总数</div>
            </div>
          </div>
        </Card>
        
        <Card>
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
              <i className="ri-building-line text-green-600 text-xl"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">{totalClients}</div>
              <div className="text-sm text-gray-600">客户总数</div>
            </div>
          </div>
        </Card>
        
        <Card>
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <i className="ri-briefcase-line text-purple-600 text-xl"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">{totalProjects}</div>
              <div className="text-sm text-gray-600">项目总数</div>
            </div>
          </div>
        </Card>
        
        <Card>
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center">
              <i className="ri-fire-line text-orange-600 text-xl"></i>
            </div>
            <div>
              <div className="text-2xl font-bold text-gray-900">{activeProjects}</div>
              <div className="text-sm text-gray-600">活跃项目</div>
            </div>
          </div>
        </Card>
      </div>

      {/* 简历解析配置 */}
      <ResumeParseConfig />

      {/* 系统参数配置 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
        <Card title="系统参数配置">
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <Button variant="outline" onClick={() => { setConfigType('process'); setShowConfigModal(true); }}>
                <i className="ri-flow-chart-line mr-2"></i>
                流程模板
              </Button>
              <Button variant="outline" onClick={() => { setConfigType('dictionary'); setShowConfigModal(true); }}>
                <i className="ri-book-line mr-2"></i>
                状态字典
              </Button>
              <Button variant="outline" onClick={() => { setConfigType('threshold'); setShowConfigModal(true); }}>
                <i className="ri-equalizer-line mr-2"></i>
                匹配阈值
              </Button>
              <Button variant="outline" onClick={() => { setConfigType('notification'); setShowConfigModal(true); }}>
                <i className="ri-notification-line mr-2"></i>
                通知策略
              </Button>
            </div>
            <div className="space-y-3 mt-6">
              <div className="flex items-center justify-between py-3 border-b border-gray-100">
                <div>
                  <h4 className="font-medium text-gray-900">简历自动解析</h4>
                  <p className="text-sm text-gray-600">AI自动提取简历关键信息</p>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-6 bg-blue-600 rounded-full relative cursor-pointer">
                    <div className="w-4 h-4 bg-white rounded-full absolute top-1 right-1 transition-all"></div>
                  </div>
                </div>
              </div>
              <div className="flex items-center justify-between py-3 border-b border-gray-100">
                <div>
                  <h4 className="font-medium text-gray-900">智能匹配推荐</h4>
                  <p className="text-sm text-gray-600">匹配阈值: 85%</p>
                </div>
                <div className="flex items-center">
                  <div className="w-10 h-6 bg-blue-600 rounded-full relative cursor-pointer">
                    <div className="w-4 h-4 bg-white rounded-full absolute top-1 right-1 transition-all"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Card>

        <Card title="审批流配置">
          <div className="space-y-4">
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <div>
                <h4 className="font-medium text-gray-900">推荐审批流</h4>
                <p className="text-sm text-gray-600">候选人推荐需要主管审批</p>
              </div>
              <Button size="sm" variant="outline">配置流程</Button>
            </div>
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <div>
                <h4 className="font-medium text-gray-900">报价审批流</h4>
                <p className="text-sm text-gray-600">项目报价需要经理审批</p>
              </div>
              <Button size="sm" variant="outline">配置流程</Button>
            </div>
            <div className="flex items-center justify-between py-3 border-b border-gray-100">
              <div>
                <h4 className="font-medium text-gray-900">面试审批流</h4>
                <p className="text-sm text-gray-600">面试安排需要确认审批</p>
              </div>
              <Button size="sm" variant="outline">配置流程</Button>
            </div>
            <div className="flex items-center justify-between py-3">
              <div>
                <h4 className="font-medium text-gray-900">Offer审批流</h4>
                <p className="text-sm text-gray-600">Offer发放需要总监审批</p>
              </div>
              <Button size="sm" variant="outline">配置流程</Button>
            </div>
          </div>
        </Card>
      </div>

      {/* 外部接口与配置 */}
      <Card title="外部接口与系统配置">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">外部接口密钥管理</h4>
            <div className="space-y-2">
              {[
                { name: '智联招聘API', status: '已配置', color: 'green' },
                { name: '猎聘网API', status: '已配置', color: 'green' },
                { name: '前程无忧API', status: '待配置', color: 'yellow' },
                { name: 'BOSS直聘API', status: '已配置', color: 'green' }
              ].map((api, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                  <span className="text-sm text-gray-700">{api.name}</span>
                  <span className={`text-xs px-2 py-1 rounded-full bg-${api.color}-100 text-${api.color}-800`}>
                    {api.status}
                  </span>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">ES/向量库配置</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">Elasticsearch</span>
                <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800">运行中</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">向量数据库</span>
                <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800">运行中</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">Redis缓存</span>
                <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800">运行中</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">归档与备份策略</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">数据归档</span>
                <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800">6个月</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">自动备份</span>
                <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800">每日</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm text-gray-700">备份保留</span>
                <span className="text-xs px-2 py-1 rounded-full bg-purple-100 text-purple-800">30天</span>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );

  const renderUserManagement = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">用户与权限管理</h2>
        <Button>
          <i className="ri-add-line mr-2"></i>
          添加用户
        </Button>
      </div>

      {/* 数据域权限控制 */}
      <Card title="数据域权限配置">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
          <div>
            <h4 className="font-medium text-gray-900 mb-3">按项目隔离</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">项目A组</span>
                <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">5个项目</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">项目B组</span>
                <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">3个项目</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">按客户隔离</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">互联网客户组</span>
                <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">12个客户</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">金融客户组</span>
                <span className="text-xs bg-orange-100 text-orange-800 px-2 py-1 rounded-full">8个客户</span>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">按团队隔离</h4>
            <div className="space-y-2">
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">华北团队</span>
                <span className="text-xs bg-yellow-100 text-yellow-800 px-2 py-1 rounded-full">6人</span>
              </div>
              <div className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <span className="text-sm">华南团队</span>
                <span className="text-xs bg-red-100 text-red-800 px-2 py-1 rounded-full">4人</span>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* 权限点配置 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="权限点配置">
          <div className="space-y-3">
            {[
              { module: '人才管理', permissions: ['查看', '新增', '编辑', '删除', '导出', '批量操作'] },
              { module: '项目管理', permissions: ['查看', '新增', '编辑', '状态变更', '分配人才'] },
              { module: '客户管理', permissions: ['查看', '新增', '编辑', '沟通记录', '合同管理'] },
              { module: '系统管理', permissions: ['用户管理', '权限配置', '系统设置', '数据导出'] }
            ].map((item, index) => (
              <div key={index} className="border border-gray-200 rounded-lg p-4">
                <div className="font-medium text-gray-900 mb-2">{item.module}</div>
                <div className="grid grid-cols-3 gap-2">
                  {item.permissions.map((perm, i) => (
                    <label key={i} className="flex items-center space-x-2">
                      <input type="checkbox" defaultChecked className="rounded" />
                      <span className="text-sm text-gray-700">{perm}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Card>

        <Card title="角色模板">
          <div className="space-y-3">
            {[
              { name: '超级管理员', users: 1, permissions: '全部权限', color: 'red' },
              { name: '招聘总监', users: 2, permissions: '项目管理、团队管理、审批权限', color: 'purple' },
              { name: '招聘经理', users: 3, permissions: '项目管理、人才管理、客户管理', color: 'blue' },
              { name: '高级顾问', users: 5, permissions: '人才管理、项目执行、客户联系', color: 'green' },
              { name: '招聘顾问', users: 8, permissions: '人才录入、简历查看、基础操作', color: 'yellow' }
            ].map((role, index) => (
              <div key={index} className="flex items-center justify-between p-3 border border-gray-200 rounded-lg">
                <div>
                  <div className="flex items-center space-x-2">
                    <span className={`w-3 h-3 bg-${role.color}-500 rounded-full`}></span>
                    <span className="font-medium text-gray-900">{role.name}</span>
                  </div>
                  <div className="text-xs text-gray-500 mt-1">{role.permissions}</div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-600">{role.users}人</div>
                  <Button size="sm" variant="outline" className="mt-1">配置</Button>
                </div>
              </div>
            ))}
          </div>
        </Card>
      </div>

      {/* 用户列表 */}
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">用户</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">角色</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">数据域</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">状态</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">最后登录</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {[
                { id: 1, name: '张总监', role: '招聘总监', domain: '全域', status: '在线', lastLogin: '2024-01-15 14:30' },
                { id: 2, name: '李经理', role: '招聘经理', domain: '华北团队', status: '离线', lastLogin: '2024-01-15 12:15' },
                { id: 3, name: '王顾问', role: '高级顾问', domain: '项目A组', status: '在线', lastLogin: '2024-01-15 16:45' },
                { id: 4, name: '赵专员', role: '招聘顾问', domain: '互联网客户组', status: '在线', lastLogin: '2024-01-15 15:20' }
              ].map(user => (
                <tr key={user.id}>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-gray-200 rounded-full flex items-center justify-center">
                        <i className="ri-user-fill text-gray-600 text-sm"></i>
                      </div>
                      <div className="ml-3">
                        <div className="text-sm font-medium text-gray-900">{user.name}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.role}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{user.domain}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      user.status === '在线' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
                    }`}>
                      {user.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{user.lastLogin}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                    <div className="flex space-x-2">
                      <Button size="sm" variant="outline">编辑</Button>
                      <Button size="sm" variant="ghost">权限</Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );

  const renderDataCenter = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">数据中心 - 可视化仪表盘</h2>
        <div className="flex space-x-4">
          <select className="border border-gray-300 rounded-md px-3 py-2 text-sm pr-8">
            <option>本月</option>
            <option>近3个月</option>
            <option>近6个月</option>
            <option>本年度</option>
          </select>
          <select className="border border-gray-300 rounded-md px-3 py-2 text-sm pr-8">
            <option>全团队</option>
            <option>华北团队</option>
            <option>华南团队</option>
          </select>
          <Button variant="outline">
            <i className="ri-download-line mr-2"></i>
            导出数据
          </Button>
        </div>
      </div>

      {/* 项目漏斗分析 */}
      <Card title="项目漏斗分析">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="h-80 bg-gradient-to-br from-blue-50 to-indigo-100 rounded-lg flex items-center justify-center relative overflow-hidden">
            <div className="absolute inset-0 bg-white/20"></div>
            <div className="text-center z-10">
              <i className="ri-funnel-line text-5xl text-blue-600 mb-4"></i>
              <p className="text-blue-800 font-medium mb-4">项目转化漏斗</p>
              <div className="space-y-3">
                <div className="bg-white/80 rounded-lg p-3">
                  <div className="text-lg font-bold text-blue-600">项目启动</div>
                  <div className="text-2xl font-bold text-blue-800">{projects.length}</div>
                </div>
                <div className="bg-white/80 rounded-lg p-3">
                  <div className="text-lg font-bold text-orange-600">候选人推荐</div>
                  <div className="text-2xl font-bold text-orange-800">{Math.floor(projects.length * 0.8)}</div>
                </div>
                <div className="bg-white/80 rounded-lg p-3">
                  <div className="text-lg font-bold text-purple-600">面试安排</div>
                  <div className="text-2xl font-bold text-purple-800">{Math.floor(projects.length * 0.6)}</div>
                </div>
                <div className="bg-white/80 rounded-lg p-3">
                  <div className="text-lg font-bold text-green-600">成功入职</div>
                  <div className="text-2xl font-bold text-green-800">{Math.floor(projects.length * 0.3)}</div>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <h4 className="font-medium text-gray-900">转化率分析</h4>
            <div className="space-y-3">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">项目→推荐</span>
                <div className="flex items-center space-x-2">
                  <div className="w-20 bg-gray-200 rounded-full h-2">
                    <div className="bg-blue-500 h-2 rounded-full" style={{width: '80%'}}></div>
                  </div>
                  <span className="font-medium text-sm">80%</span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">推荐→面试</span>
                <div className="flex items-center space-x-2">
                  <div className="w-20 bg-gray-200 rounded-full h-2">
                    <div className="bg-orange-500 h-2 rounded-full" style={{width: '75%'}}></div>
                  </div>
                  <span className="font-medium text-sm">75%</span>
                </div>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">面试→入职</span>
                <div className="flex items-center space-x-2">
                  <div className="w-20 bg-gray-200 rounded-full h-2">
                    <div className="bg-green-500 h-2 rounded-full" style={{width: '50%'}}></div>
                  </div>
                  <span className="font-medium text-sm">50%</span>
                </div>
              </div>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg mt-4">
              <h5 className="font-medium text-blue-800 mb-2">关键指标</h5>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="text-2xl font-bold text-blue-600">28天</div>
                  <div className="text-sm text-blue-700">平均招聘周期</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-blue-600">30%</div>
                  <div className="text-sm text-blue-700">总体成功率</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Card>

      {/* 顾问业绩分析 */}
      <Card title="顾问业绩分析">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="lg:col-span-2">
            <div className="h-64 bg-gradient-to-br from-green-50 to-emerald-100 rounded-lg flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 bg-white/20"></div>
              <div className="text-center z-10">
                <i className="ri-bar-chart-line text-5xl text-green-600 mb-4"></i>
                <p className="text-green-800 font-medium mb-4">顾问业绩排行</p>
                <div className="grid grid-cols-3 gap-4">
                  {[
                    { name: '王总监', projects: 8, success: 6 },
                    { name: '李经理', projects: 6, success: 4 },
                    { name: '张顾问', projects: 5, success: 4 }
                  ].map((consultant, index) => (
                    <div key={index} className="bg-white/80 rounded-lg p-3">
                      <div className="text-lg font-bold text-green-600">{consultant.name}</div>
                      <div className="text-sm text-green-700">{consultant.projects}个项目</div>
                      <div className="text-sm text-green-700">{consultant.success}个成功</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div>
            <h4 className="font-medium text-gray-900 mb-3">业绩详情</h4>
            <div className="space-y-3">
              {[
                { name: '王总监', projects: 8, success: 6, rate: 75 },
                { name: '李经理', projects: 6, success: 4, rate: 67 },
                { name: '张顾问', projects: 5, success: 4, rate: 80 },
                { name: '赵专员', projects: 4, success: 2, rate: 50 }
              ].map((item, index) => (
                <div key={index} className="p-3 bg-gray-50 rounded-lg">
                  <div className="flex items-center justify-between mb-1">
                    <span className="font-medium text-gray-900">{item.name}</span>
                    <span className="text-sm font-medium text-green-600">{item.rate}%</span>
                  </div>
                  <div className="text-sm text-gray-600">
                    {item.projects}个项目 · {item.success}个成功
                  </div>
                  <div className="w-full bg-gray-200 rounded-full h-1 mt-2">
                    <div className="bg-green-500 h-1 rounded-full" style={{width: `${item.rate}%`}}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>

      {/* 客户活跃度与人才转化 */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card title="客户活跃度分析">
          <div className="space-y-4">
            <div className="h-48 bg-gradient-to-br from-purple-50 to-violet-100 rounded-lg flex items-center justify-center">
              <div className="text-center">
                <i className="ri-customer-service-line text-4xl text-purple-600 mb-3"></i>
                <p className="text-purple-800 font-medium">客户活跃度分布</p>
                <div className="grid grid-cols-3 gap-2 mt-4">
                  <div className="bg-white/80 rounded p-2">
                    <div className="text-lg font-bold text-green-600">45%</div>
                    <div className="text-xs text-green-700">高活跃</div>
                  </div>
                  <div className="bg-white/80 rounded p-2">
                    <div className="text-lg font-bold text-yellow-600">35%</div>
                    <div className="text-xs text-yellow-700">中活跃</div>
                  </div>
                  <div className="bg-white/80 rounded p-2">
                    <div className="text-lg font-bold text-red-600">20%</div>
                    <div className="text-xs text-red-700">低活跃</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">高活跃客户</span>
                <span className="font-medium text-green-600">{Math.floor(clients.length * 0.45)}个</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">中活跃客户</span>
                <span className="font-medium text-yellow-600">{Math.floor(clients.length * 0.35)}个</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">低活跃客户</span>
                <span className="font-medium text-red-600">{Math.floor(clients.length * 0.20)}个</span>
              </div>
            </div>
          </div>
        </Card>

        <Card title="人才转化分析">
          <div className="space-y-4">
            <div className="h-48 bg-gradient-to-br from-orange-50 to-amber-100 rounded-lg flex items-center justify-center">
              <div className="text-center">
                <i className="ri-user-star-line text-4xl text-orange-600 mb-3"></i>
                <p className="text-orange-800 font-medium">人才转化漏斗</p>
                <div className="grid grid-cols-2 gap-2 mt-4">
                  <div className="bg-white/80 rounded p-3">
                    <div className="text-xl font-bold text-orange-600">{talents.length}</div>
                    <div className="text-xs text-orange-700">总人才数</div>
                  </div>
                  <div className="bg-white/80 rounded p-3">
                    <div className="text-xl font-bold text-green-600">{Math.floor(talents.length * 0.25)}</div>
                    <div className="text-xs text-green-700">成功推荐</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">推荐转化率</span>
                <span className="font-medium text-blue-600">25%</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">面试通过率</span>
                <span className="font-medium text-purple-600">65%</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-600">最终入职率</span>
                <span className="font-medium text-green-600">45%</span>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );

  const renderAuditLogs = () => (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-semibold text-gray-900">日志与审计</h2>
        <div className="flex space-x-4">
          <Input placeholder="搜索日志..." className="w-64" />
          <Button variant="outline">
            <i className="ri-filter-line mr-2"></i>
            筛选
          </Button>
        </div>
      </div>

      {/* 操作日志 */}
      <Card title="操作日志">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">时间</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">用户</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">操作</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">模块</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">详情</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">IP地址</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {[
                { time: '2024-01-15 16:30:25', user: '张总监', action: '数据变更', module: '人才管理', detail: '修改人才状态：李明 待沟通→面试中', ip: '192.168.1.100' },
                { time: '2024-01-15 16:25:12', user: '李经理', action: '权限变更', module: '用户管理', detail: '分配数据域权限：项目A组', ip: '192.168.1.101' },
                { time: '2024-01-15 16:20:08', user: '王顾问', action: '沟通记录', module: '客户管理', detail: '添加沟通记录：阿里巴巴-项目讨论', ip: '192.168.1.102' },
                { time: '2024-01-15 16:15:33', user: '赵专员', action: '批量操作', module: '人才管理', detail: '批量导入简历：15份', ip: '192.168.1.103' },
                { time: '2024-01-15 16:10:45', user: '张总监', action: '数据导出', module: '数据管理', detail: '导出人才数据报表', ip: '192.168.1.100' }
              ].map((log, index) => (
                <tr key={index}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{log.time}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{log.user}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                      log.action === '数据变更' ? 'bg-blue-100 text-blue-800' :
                      log.action === '权限变更' ? 'bg-purple-100 text-purple-800' :
                      log.action === '沟通记录' ? 'bg-green-100 text-green-800' :
                      log.action === '批量操作' ? 'bg-orange-100 text-orange-800' :
                      'bg-gray-100 text-gray-800'
                    }`}>
                      {log.action}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{log.module}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{log.detail}</td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{log.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>

      {/* 数据变更历史 */}
      <Card title="数据变更历史">
        <div className="space-y-4">
          {[
            {
              time: '2024-01-15 16:30:25',
              user: '张总监',
              table: '人才表',
              record: '李明(ID:1001)',
              field: 'status',
              oldValue: '待沟通',
              newValue: '面试中',
              reason: '客户确认面试安排'
            },
            {
              time: '2024-01-15 16:25:12',
              user: '李经理',
              table: '项目表',
              record: '前端开发工程师(ID:2001)',
              field: 'salary',
              oldValue: '15K-25K',
              newValue: '18K-30K',
              reason: '客户调整薪资预算'
            },
            {
              time: '2024-01-15 16:20:08',
              user: '王顾问',
              table: '客户表',
              record: '阿里巴巴(ID:3001)',
              field: 'cooperation_status',
              oldValue: '新客户',
              newValue: '活跃合作',
              reason: '项目合作确认'
            }
          ].map((change, index) => (
            <div key={index} className="bg-gray-50 p-4 rounded-lg">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-2">
                  <i className="ri-history-line text-blue-600"></i>
                  <span className="font-medium text-gray-900">{change.table} - {change.record}</span>
                </div>
                <span className="text-sm text-gray-500">{change.time}</span>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 text-sm">
                <div>
                  <span className="text-gray-500">字段:</span>
                  <span className="font-medium ml-1">{change.field}</span>
                </div>
                <div>
                  <span className="text-gray-500">原值:</span>
                  <span className="text-red-600 ml-1">{change.oldValue}</span>
                </div>
                <div>
                  <span className="text-gray-500">新值:</span>
                  <span className="text-green-600 ml-1">{change.newValue}</span>
                </div>
                <div>
                  <span className="text-gray-500">操作人:</span>
                  <span className="font-medium ml-1">{change.user}</span>
                </div>
              </div>
              {change.reason && (
                <div className="mt-2 text-sm text-gray-600">
                  <span className="text-gray-500">变更原因:</span> {change.reason}
                </div>
              )}
            </div>
          ))}
        </div>
      </Card>

      {/* 沟通审计 */}
      <Card title="沟通审计 - 原始录音/聊天存证">
        <div className="space-y-4">
          {[
            {
              time: '2024-01-15 14:30:00',
              type: '电话录音',
              participants: '张总监 ↔ 李明(候选人)',
              duration: '12分35秒',
              summary: 'AI摘要：讨论前端开发岗位，候选人对薪资期望25K，可接受996工作制',
              status: '已存证',
              recordId: 'CALL_20240115_001'
            },
            {
              time: '2024-01-15 13:45:00',
              type: '微信聊天',
              participants: '王顾问 ↔ 阿里巴巴HR',
              duration: '25条消息',
              summary: 'AI摘要：确认面试时间安排，客户要求技术面试+HR面试两轮',
              status: '已存证',
              recordId: 'CHAT_20240115_002'
            },
            {
              time: '2024-01-15 11:20:00',
              type: '邮件往来',
              participants: '李经理 ↔ 腾讯招聘负责人',
              duration: '3封邮件',
              summary: 'AI摘要：项目需求讨论，确认Java后端工程师JD要求',
              status: '已存证',
              recordId: 'EMAIL_20240115_003'
            }
          ].map((audit, index) => (
            <div key={index} className="border border-gray-200 rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center space-x-3">
                  <i className={`${
                    audit.type === '电话录音' ? 'ri-phone-line' :
                    audit.type === '微信聊天' ? 'ri-chat-3-line' :
                    'ri-mail-line'
                  } text-blue-600 text-lg`}></i>
                  <div>
                    <div className="font-medium text-gray-900">{audit.type}</div>
                    <div className="text-sm text-gray-600">{audit.participants}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm text-gray-500">{audit.time}</div>
                  <span className="px-2 py-1 bg-green-100 text-green-800 rounded-full text-xs">
                    {audit.status}
                  </span>
                </div>
              </div>
              <div className="bg-blue-50 p-3 rounded-lg mb-3">
                <div className="text-sm text-blue-800">{audit.summary}</div>
              </div>
              <div className="flex items-center justify-between text-sm">
                <div className="flex items-center space-x-4">
                  <span className="text-gray-500">时长: {audit.duration}</span>
                  <span className="text-gray-500">存证ID: {audit.recordId}</span>
                </div>
                <div className="flex space-x-2">
                  <Button size="sm" variant="outline">播放/查看</Button>
                  <Button size="sm" variant="outline">下载原文</Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </Card>
    </div>
  );

  const renderConfigModal = () => {
    if (!showConfigModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto">
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center justify-between">
              <h2 className="text-xl font-semibold text-gray-900">
                {configType === 'process' ? '流程模板配置' :
                 configType === 'dictionary' ? '状态字典配置' :
                 configType === 'threshold' ? '匹配阈值配置' :
                 configType === 'notification' ? '通知策略配置' : '系统配置'}
              </h2>
              <button
                onClick={() => setShowConfigModal(false)}
                className="text-gray-400 hover:text-gray-600 cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>
          </div>
          
          <div className="p-6">
            {configType === 'process' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900">审批流程模板</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <Card title="推荐审批流">
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                          <span className="text-blue-600 font-bold text-sm">1</span>
                        </div>
                        <div>
                          <div className="font-medium">顾问提交</div>
                          <div className="text-sm text-gray-500">候选人推荐</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                          <span className="text-orange-600 font-bold text-sm">2</span>
                        </div>
                        <div>
                          <div className="font-medium">主管审批</div>
                          <div className="text-sm text-gray-500">质量把控</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                          <span className="text-green-600 font-bold text-sm">3</span>
                        </div>
                        <div>
                          <div className="font-medium">推送客户</div>
                          <div className="text-sm text-gray-500">正式推荐</div>
                        </div>
                      </div>
                    </div>
                  </Card>
                  <Card title="Offer审批流">
                    <div className="space-y-3">
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                          <span className="text-blue-600 font-bold text-sm">1</span>
                        </div>
                        <div>
                          <div className="font-medium">客户发起</div>
                          <div className="text-sm text-gray-500">Offer意向</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-purple-100 rounded-full flex items-center justify-center">
                          <span className="text-purple-600 font-bold text-sm">2</span>
                        </div>
                        <div>
                          <div className="font-medium">总监审批</div>
                          <div className="text-sm text-gray-500">风险评估</div>
                        </div>
                      </div>
                      <div className="flex items-center space-x-3 p-3 bg-gray-50 rounded">
                        <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                          <span className="text-green-600 font-bold text-sm">3</span>
                        </div>
                        <div>
                          <div className="font-medium">正式发放</div>
                          <div className="text-sm text-gray-500">Offer确认</div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </div>
              </div>
            )}
            
            {configType === 'threshold' && (
              <div className="space-y-6">
                <h3 className="text-lg font-semibold text-gray-900">AI匹配阈值配置</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">技能匹配阈值</label>
                    <input type="range" min="0" max="100" defaultValue="85" className="w-full" />
                    <div className="flex justify-between text-sm text-gray-500 mt-1">
                      <span>0%</span>
                      <span className="font-medium">85%</span>
                      <span>100%</span>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">经验匹配阈值</label>
                    <input type="range" min="0" max="100" defaultValue="75" className="w-full" />
                    <div className="flex justify-between text-sm text-gray-500 mt-1">
                      <span>0%</span>
                      <span className="font-medium">75%</span>
                      <span>100%</span>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="flex justify-end space-x-4 mt-8">
              <Button variant="outline" onClick={() => setShowConfigModal(false)}>取消</Button>
              <Button>保存配置</Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      <div className="max-w-7xl mx-auto px-6 py-8">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900 mb-2">系统管理</h1>
          <p className="text-gray-600">系统综合管理、用户权限、数据中心和审计日志</p>
        </div>

        {/* 标签页导航 */}
        <div className="mb-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', name: '综合管理', icon: 'ri-dashboard-line' },
              { id: 'users', name: '用户与权限', icon: 'ri-user-settings-line' },
              { id: 'data', name: '数据中心', icon: 'ri-bar-chart-line' },
              { id: 'logs', name: '日志与审计', icon: 'ri-file-list-line' }
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center space-x-2 px-4 py-2 border-b-2 font-medium text-sm cursor-pointer whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                <i className={`${tab.icon} text-base`}></i>
                <span>{tab.name}</span>
              </button>
            ))}
          </nav>
        </div>

        {/* 标签页内容 */}
        {activeTab === 'overview' && renderOverview()}
        {activeTab === 'users' && renderUserManagement()}
        {activeTab === 'data' && renderDataCenter()}
        {activeTab === 'logs' && renderAuditLogs()}
      </div>

      {renderConfigModal()}
    </div>
  );
}
